import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { makeStyles } from './ModalTitle.styles';
import Icon from '../../Icon/Icon';
import { useTheme } from '../../../hooks/useTheme';

interface Props {
  title: string;
  onDismiss?: () => void;
}

const ModalTitle: React.FC<Props> = ({ title, onDismiss }) => {
  const { colors } = useTheme();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  return (
    <View style={styles.container}>
      <TouchableOpacity
        testID="btn-close"
        onPress={onDismiss}
        style={styles.btnClose}
      >
        <Icon size={20} name="UilTimes" color={colors.text} />
      </TouchableOpacity>
      <Text testID="mdl-title" style={styles.title}>
        {title}
      </Text>
    </View>
  );
};

export default ModalTitle;
